export function isMobile() {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
}


function parseDuration(text){
  let durationParts = String(text ?? '').trim().split(/\s+/).filter(Boolean);
  if (!durationParts.length) return null;
  let count = parseInt(durationParts[0], 10);
  // Accept both "3 months" and a bare "month"
  let unit = isNaN(count) ? durationParts.join(' ') : durationParts.slice(1).join(' ');
  if (!unit) return null;
  return { count: isNaN(count) ? 1 : count, unit: unit };
}

function unitLabel(unit, count){
  let singularUnit = unit.replace(/s$/i, '').toLowerCase();
  return count > 1 ? singularUnit + 's' : singularUnit;
}

export function durationText(text){
  let duration = parseDuration(text);
  if (!duration) return String(text ?? '').trim();
  let label = unitLabel(duration.unit, duration.count);
  return duration.count + ' ' + label.charAt(0).toUpperCase() + label.slice(1);
}

// Billing period label, e.g. "month" for "1 month" and "3 months" for "3 months"
export function durationUnit(text){
  let duration = parseDuration(text);
  if (!duration) return String(text ?? '').trim();
  let label = unitLabel(duration.unit, duration.count);
  return duration.count > 1 ? duration.count + ' ' + label : label;
}